import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const TopConfirmationModal = ({ data, isOpen, toggle, onConfirm, status }) => {
    console.log("data",data);
    
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Change Status</ModalHeader>
      <ModalBody>
        Are you sure you want to{" "} {data?.isSelected ? "remove from top 20 list." : "add to top 20 list."}
          
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color={
            data?.isSelected === "active" || data?.isSelected === true
              ? "primary"
              : data?.isSelected === "inactive" || data?.isSelected === false || data?.isSelected == "Inactive"
              ? "success"
              : "danger"
          }
          onClick={onConfirm}
        >
          Yes{" "}
          
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TopConfirmationModal;
